import { render, staticRenderFns } from "./FichaTecnica.vue?vue&type=template&id=787daaf5&"
import script from "./FichaTecnica.vue?vue&type=script&lang=js&"
export * from "./FichaTecnica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports